import InAppSpy from "inapp-spy";
import DialogComponentWithBodyChildren from "./DialogComponentWithBodyChildren";
import React, {useState} from "react";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {useTranslation} from "react-i18next";

export default function InstagramWarning() {
    const { t } = useTranslation('translation', { keyPrefix: 'instagramWarning' });
    const {isInApp, appName} = InAppSpy();
    const [accepted, setAccepted] = useState(false)

    return <>
        {isInApp && !accepted && <DialogComponentWithBodyChildren
            title="Application opened in in-app browser"
            onClose={() => setAccepted(true)}
            onConfirm={() => setAccepted(true)}
        >
            <div style={{display: "flex", flexDirection: "row"}}>
                <WarningAmberIcon htmlColor={"red"}/>
                <div style={{fontWeight: "bold"}}>{t('errorsPossible')}</div>
                <WarningAmberIcon htmlColor={"red"}/>
            </div>
            <div>{t('pagedOpenedWithExternalBrowser')} {appName}</div>
            <div>{t('openInNormalBrowser')}</div>
            <br/>
            <div>- {t('howTo1')}</div>
            <div> {t('or')}</div>
            <div>- {t('howTo2')}</div>
        </DialogComponentWithBodyChildren>
        }
    </>
}